import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const Wrapper = styled.div<{ displayOnly?: boolean }>`
  margin: 0 -15px 32px -5px;
  ${media.md`
    margin: 0 0px 32px -5px;
  `};
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  * {
    cursor: ${({ displayOnly }) => (displayOnly ? 'default' : 'pointer')};
  }
`;

export const Slider = styled.div`
  display: inline-flex;
`;
